import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { CoursesDirectory } from "@/react/types/CoursesDirectory";

export interface UpdateCoursesDirectoryPayload
  extends Omit<
    CoursesDirectory,
    "courses" | "logged_in_banner_image" | "logged_out_banner_image"
  > {
  courses_order: string[];
  custom_lesson_label: string;
  custom_section_label: string;
  logged_in_banner_image: string | null;
  logged_out_banner_image: string | null;
}

const show = () => reactQueryGet(internalApi.courses.directory.show());

const update = (payload: UpdateCoursesDirectoryPayload) =>
  reactQueryPut<CoursesDirectory, UpdateCoursesDirectoryPayload>(
    internalApi.courses.directory.update(),
    payload,
  );

export const coursesDirectoryApi = {
  show,
  update,
};
